import { render, staticRenderFns } from "./RestaurantMenuProduct.vue?vue&type=template&id=e1f111e8&"
import script from "./RestaurantMenuProduct.vue?vue&type=script&lang=js&"
export * from "./RestaurantMenuProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports